import http from '@/utils/http';
import config from '@/config/user.env';
import { method } from 'lodash';

const findCurrUserUrl = '/mframework/findCurrUser';

/* 本地新接口 */
const getResuorceBySysAuthUrl = '/gscint/menu/getResourcesBySystem/GSC_I';
const switchLangUrl = '/gscint/menu/savePersonConf';

/* 云平台旧接口 */
const cloudSwitchLangUrl = '/mframework/sys/org/savePersonConf';
const cloudUrl = `/mframework/sys/authority/sysAuthResource/getResuorceBySysAuth?appId=${config.appId}`;
const isPro = window.environment.isPro;
const srmSwitchLangUrl = '/srmbase/basePersonConf/savePersonConf';

/**
 * 登录后查找当前用户信息
 */
export function findCurrUser() {
  return http({
    url: findCurrUserUrl,
    method: 'post',
  }).then(res => {
    const { user = {} } = res.data.data || {};
    localStorage.setItem('user', JSON.stringify(user));
    return res.data;
  });
}

/**
 * 获取菜单
 */
export function getResuorceBySysAuth(isNewMenu) {
  return http({
    url: isNewMenu ? getResuorceBySysAuthUrl : cloudUrl,
    method: 'get',
  }).then(res => res.data);
}

/**
 * 语言切换
 */
export async function switchLang(langType, isNewMenu) {
	/* 旧菜单把日语当作泰文 */
    if (!isNewMenu) {
        langType = langType === 'th' ? 'ja-JP' : langType;
    } else {
        /* 切换SRM接口语言 */
        await http({
            url: srmSwitchLangUrl,
            method: 'post',
            data: {
                langType,
            },
        });
        /* 新菜单需要调用共享平台的旧接口 */
        http({
            url: cloudSwitchLangUrl,
            method: 'post',
            data: {
                langType: langCnOrEn(langType),
            },
        });
    }
    /* 把日语模拟成阿拉伯语 */
    if (langType === 'ar') {
        langType = 'ja-JP';
    }
    return http({
        url: isNewMenu ? switchLangUrl : cloudSwitchLangUrl,
        method: 'post',
        data: {
            langType,
        },
    });
}

/*
    语言转换
*/
export function changeLanKey(key) {
    const lang = {
        'zh-CN': 'zh',
        'en-US': 'en',
        'ja-JP': 'ja',
		'th': 'th',
        'vi': 'vi',
        'ar': 'ar',
    };
    return lang[key] || key;
}

/*
   获取开发云菜单权限
*/
export function getCloudMenu(isNewMenu) {
	/* 旧菜单不需要调用 */
    if (!isNewMenu) {
        return {};
    }
    return http({
        url: cloudUrl,
        method: 'get',
    }).then(res => res.data);
}

/*
    菜单合并
*/
export function menuMerge(int, gsc) {
    return gsc.filter((item) => item.fdKey === `${isPro ? 'GSCNEW' : 'gsc_new'}`).concat(int);
}

/**
 * 获取国际化采用方案配置字典
 */
export function queryLanguageSource() {
    return http({
        url: '/srmbase/basicConfig/queryDictionaryType',
        method: 'post',
        data: { dictionaryCode: 'LANGUAGE_SOURCE_GSC', language: 'zh-CN' },
        // 该接口无需报错，所以统一让axios返回resolve
        validateStatus() {
            return true; // 默认值
        },
    }).then(res => res.data);
}

/*
    非中文语言下兜底英文
*/
export function langCnOrEn(lang) {
    switch (lang) {
        case 'zh-CN':
            break;
        default:
            lang = 'en-US';
    }
    return lang;
}
